<template>
    <b-modal
      :id="id"
      hide-footer
      :title="title"
      @shown="onShown"
      @hidden="onHidden"
    >
      <b-overlay :show="busy" class="text-center">
        <b-table
            ref="table"
            class="bg-white"
            responsive
            show-empty
            :fields="fields"
            :items="items"
        />
      </b-overlay>
    </b-modal>
  </template>
  
  <script>
    export default {
      props: {
        id: {
          type: String,
          default: 'client-attendance-modal',
        },
        organization: Object,
        event: Object,
        title: {
          type: String,
          default: trans('attendance')
        },
      },
      data() {
        return {
          busy: false,
          participants: [],
        }
      },
      computed: {
        fields() {
            return _.compact([
            {
                key: 'name',
                label: trans('name'),
            }])
        },
        items() {
            return this.participants
        },
      },
      methods: {
        onShown() {
          this.busy = false
          this.load()
        },
        onHidden() {
          this.$emit('hidden')
        },
        load() {
          this.busy = true
          this.error = null
          let url = `/org/${this.organization.id}/attendance/${this.event.am_class_id}/event/${this.event.id}/participant`
          return axios.get(url)
          .then(response => {
            this.busy = false
            this.participants = response.data
          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
            _.toastError(this, this.error)
          })
        }
      },
      mounted() {
        window[_.camelCase(this.id)] = this
      },
    }
  </script>